import { Apis } from '@/appSettings'
import type { SetCommissionPaidDatesRequest } from '@/dtos/Commissions/SetCommissionPaidDatesRequest'
import type { SetCommissionPaidDatesResponse } from '@/dtos/Commissions/SetCommissionPaidDatesResponse'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { returnArray } from 'BrokerTsLib/src/Utils/reactQueryUtils'
import { useMutation } from 'react-query'
import { useUrl } from '.'


export const useSetCommissionPaidDates = () => {
  const url = useUrl(Apis.commissions)

  return useMutation({
    mutationFn:(request: SetCommissionPaidDatesRequest) => 
      apiClient.post<SetCommissionPaidDatesResponse>(`${url}/SetCommissionPaidDates`, request).then(returnArray)
  })
}